import type { IDisplayAdsFormatFilterDto } from "app/pages/sales-intelligence/modules/leads-search-filters/types/leadsSearchFilters.dto";
import type { ColumnByKeys } from "app/pages/sales-intelligence/sub-modules/common/services/company-search-column-suggestions/types/column-by-keys";
import type { SuggestedColumnName } from "app/pages/sales-intelligence/sub-modules/common/services/company-search-column-suggestions/types/columns";
import { processColumnsByKeys } from "app/pages/sales-intelligence/sub-modules/common/services/company-search-column-suggestions/utils/processColumnsByKeys";

import * as columnNames from "../../constants/column-names";

const COLUMNS_BY_KEYS: ColumnByKeys<IDisplayAdsFormatFilterDto> = {
    bannerShare: [columnNames.DISPLAY_ADS_BANNER_SHARE_FIELD],
    videoShare: [columnNames.DISPLAY_ADS_VIDEO_SHARE_FIELD],
    nativeShare: [columnNames.DISPLAY_ADS_NATIVE_SHARE_FIELD],
};

const processDisplayAdsFormatFilter = (filterDto: Partial<IDisplayAdsFormatFilterDto>): readonly SuggestedColumnName[] => {
    return processColumnsByKeys<IDisplayAdsFormatFilterDto>(filterDto, COLUMNS_BY_KEYS);
};

export default processDisplayAdsFormatFilter;
